import { useEffect, useRef } from 'react';
import { initMapView, useMapStore } from './mapStore';

export function MapView() {
  const ref = useRef<HTMLDivElement>(null);
  const status = useMapStore((s) => s.status);
  const error = useMapStore((s) => s.error);

  useEffect(() => {
    if (!ref.current) return;
    void initMapView(ref.current).catch(() => {
      // status + error captured in the store
    });
  }, []);

  return (
    <div className="rcmc-map-host relative h-full w-full">
      <div ref={ref} className="absolute inset-0" />
      {status !== 'ready' && (
        <div className="pointer-events-none absolute inset-0 grid place-items-center text-xs text-muted-foreground">
          {status === 'error' ? `Map error: ${error}` : 'Loading map…'}
        </div>
      )}
    </div>
  );
}
